import { TileLayer, BitmapLayer, H3HexagonLayer } from "deck.gl";

export class OSMLayer extends TileLayer {
  constructor() {
    super({
      id : 'osm-layer',

      data: [
        'https://tile.openstreetmap.org/{z}/{x}/{y}.png'
      ],

      tileSize: 256,

      renderSubLayers: (props) => {
        const {
          bbox: { west, south, east, north }
        } = props.tile;

        return new BitmapLayer(props, {
          data: null,
          image: props.data,
          bounds: [west, south, east, north],
        });
      }
    });
  };
}

export function renderDataLayer(props) {
  const layer = new H3HexagonLayer({
    id: props.id + "-layer",
    data: props.bloomList,
    getHexagon: d => d.h3,
    getFillColor: props.color,
    extruded: true,
    getElevation: d => {
      switch(props.id) {
      case "bloom-start":
        return (props.date - d.date_start) / (24 * 60 * 60 * 1000) + 1;

      case "bloom-full":
        return (props.date - d.date_start) / (24 * 60 * 60 * 1000) + 1;

      default:
        return 0;
      }
    },
    elevationScale: 3000,
  });

  return layer;
}

export function renderAllLayers(props) {
  const osmLayer = new OSMLayer();
  const bloomStartLayer = (props.bloomStartList?.length > 0)? renderDataLayer({id: "bloom-start", bloomList: props.bloomStartList, color: [255,170,200,200], date: props.date}) : null;
  const bloomFullLayer = (props.bloomFullList?.length > 0)? renderDataLayer({id: "bloom-full", bloomList: props.bloomFullList, color: [220,70,150,200], date: props.date}) : null;
  const bloomEndLayer = (props.bloomEndList?.length > 0)? renderDataLayer({id: "bloom-end", bloomList: props.bloomEndList, color: [120,190,70,200], date: props.date}) : null;

  return [
    osmLayer,
    bloomStartLayer,
    bloomFullLayer,
    bloomEndLayer,
  ];
}
